import React from 'react'
import { PlayerList } from 'src/pages/worldCup2026/players/list'

export const WorldCup2026PlayersPage = () => {
  return <PlayerList />
}
